import { TEN_MB_IN_BYTES } from "./bytesToMegaBytes";

/**
 * Max size for a task reaction/attachment file uploaded from the
 * Approval / Rejection / Revision pop-ups.
 */
export const MAX_REACTION_FILE_SIZE_BYTES = TEN_MB_IN_BYTES;

/**
 * Always-visible caption of the upload row in the review pop-ups —
 * rendered uppercase ("FILE (MAX. FILE SIZE 10 MB)") by the section style.
 */
export const MAX_FILE_SIZE_HELP_TEXT = "File (max. file size 10 MB)";

/** Error shown when a selected file exceeds the limit. */
export const FILE_SIZE_LIMIT_ERROR = "File must be 10 MB or smaller";

/** Whether a single file is within the size limit. */
export const isFileWithinSizeLimit = (
  file: { size: number },
  limit: number = MAX_REACTION_FILE_SIZE_BYTES
): boolean => file.size <= limit;

/**
 * Whether any selected reaction file exceeds the size limit. Drives the
 * inline error message and the disabled Submit state in the review pop-ups —
 * the over-limit file stays in the list so the user can see and remove it.
 */
export const hasOversizedFile = (
  files: Array<{ file: { size: number } }>,
  limit: number = MAX_REACTION_FILE_SIZE_BYTES
): boolean => files.some((entry) => !isFileWithinSizeLimit(entry.file, limit));
